import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { processSteps } from "@/mocks/site";

export default function ProcessSection() {
  return (
    <section id="surec" className="scroll-mt-24 bg-background-100 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Nasıl çalışır?"
            title="4 adımda çekiminizi tamamlayın"
            description="Diş hekiminizin yönlendirmesinden sonucun teslimine kadar süreç tamamen dijital ve hızlıdır."
          />
        </Reveal>

        <div className="relative mt-16">
          <div
            className="absolute left-0 right-0 top-7 hidden h-px bg-background-300 lg:block"
            aria-hidden="true"
          />
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
            {processSteps.map((step, index) => (
              <Reveal key={step.step} delay={index * 90}>
                <div className="relative">
                  <span className="relative z-10 flex h-14 w-14 items-center justify-center rounded-full border border-background-300 bg-background-50 font-heading text-lg font-medium text-primary-700">
                    {step.step}
                  </span>
                  <h3 className="mt-6 font-heading text-lg font-medium tracking-tight text-foreground-950">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{step.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}